var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _c(
        "el-select",
        {
          attrs: {
            filterable: "",
            remote: "",
            "reserve-keyword": "",
            placeholder: "请输入关键词",
            clearable: "",
            multiple: _vm.multiple,
            "remote-method": _vm.ownerRemoteMethod,
            loading: _vm.ownerLoading,
          },
          on: { change: _vm.handleChange },
          model: {
            value: _vm.customer,
            callback: function ($$v) {
              _vm.customer = $$v
            },
            expression: "customer",
          },
        },
        _vm._l(_vm.ownerRemoteList, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: item.name, value: item.id },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }